import React from 'react'
import styled from '@emotion/styled'
import { withTheme } from 'emotion-theming'
import Img from 'gatsby-image'
import { Badge } from '@jelly/components'
import { Link } from '@jelly/ui'
import { pushGtmData } from '@jelly/utils'

const Wrapper = styled.div`
	border: ${({ theme }) => theme.borders.default};
	box-shadow: ${({ theme }) => theme.shadows.small};
	display: flex;
	flex-direction: column;
	margin-bottom: 3rem;
	width: 100%;

	${({ theme }) => theme.MQ.M} {
		width: 350px;
	}
`
const Content = styled.div`
	display: flex;
	flex-direction: column;
	flex-grow: 1;
	padding: 1rem;
`
const Title = styled.h3`
	border-bottom: ${({ theme }) => theme.borders.default};
	min-height: 3.5rem;
	margin-bottom: 0;
`
const LinkWrapper = styled.div`
	align-self: flex-end;
	margin-top: auto;
`
const ImageAttribution = styled.small`
	bottom: 0.5rem;
	color: rgba(255, 255, 255, 0.8);
	font-size: 9px;
	position: absolute;
	right: 0.5rem;
	text-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
`
const ImageLink = styled(Link)`
	position: relative;
`

function Resource({ attribution, description, fluid, image, isNew, link, tag, title }) {
	const linkAttributes = { href: link, rel: 'noopener noreferrer', target: '_blank' }
	const handleLinkClick = (placement) => {
		pushGtmData({
			event: 'gaEvent',
			gaEventCategory: 'Mktg Resource Click',
			gaEventAction: title,
			gaEventLabel: placement,
			gaEventNoninteraction: false,
		})
	}
	return (
		<Wrapper>
			<ImageLink {...linkAttributes} onClick={() => handleLinkClick('image')}>
				<Img fluid={fluid} alt={image.split('.')[0]} />
				<ImageAttribution>{attribution}</ImageAttribution>
			</ImageLink>
			<Content>
				<div>
					<Badge context={tag} />
					{isNew && <Badge context="NEW" variant="secondary" />}
				</div>
				<Link {...linkAttributes} onClick={() => handleLinkClick('title')}>
					<Title>{title}</Title>
				</Link>
				<p>{description}</p>
				<LinkWrapper>
					<Link {...linkAttributes} onClick={() => handleLinkClick('link')}>
						{tag === 'Video' ? 'Watch' : 'Download'} &gt;
					</Link>
				</LinkWrapper>
			</Content>
		</Wrapper>
	)
}

export default withTheme(Resource)
